import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './SearchResults.css';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SearchResults = () => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const query = useQuery();
    const searchQuery = query.get('query');

    useEffect(() => {
        const fetchSearchResults = async () => {
            const options = {
                method: 'GET',
                headers: {
                    accept: 'application/json',
                    Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3NDY1NzM0ZjNlM2IxMDk0MTEzNjRjMzRlNGI1MDAyYyIsInN1YiI6IjY2NDRhNmZiNGVjNjY1ODBkMGVlYTMyNiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.BApYsoZnnAmhTEgS_h022LArcrQw9hvP6hdA-Bw9mdQ'
                }
            };

            try {
                const response = await fetch(`https://api.themoviedb.org/3/search/movie?query=${searchQuery}`, options);
                const data = await response.json();
                setResults(data.results);
                setLoading(false);
            } catch (error) {
                setError(error.message || 'An error occurred while fetching search results');
                setLoading(false);
            }
        };

        if (searchQuery) {
            fetchSearchResults();
        }
    }, [searchQuery]);

    if (loading) {
        return <div className="loading-message">Loading...</div>;
    }

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    if (results.length === 0) {
        return <div className="no-results-message">No results found for "{searchQuery}"</div>;
    }

    return (
        <div className="search-results-container">
            <h2 className='title'>Search Results for "{searchQuery}"</h2>
            <div className="movie-grid">
                {results.map(movie => (
                    <div key={movie.id} className="movie-card">
                        <img className="movie-poster" src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`} alt={movie.title} />
                        <div className="movie-info">
                            <h3>{movie.title}</h3>
                            <p>{movie.release_date}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SearchResults;
